import {config} from './hapi.config';

// https://nuxt.com/docs/api/configuration/nuxt-config
export default defineAppConfig({
	host: config[config.default].host,
	lang: 'si',
	baseCompatibility: '1.28.0',
	cache: {
		debug: false,
		enabled: config[config.default].apiCache,
		refresh: {
			currency: 1440, // 24 hours
			endpoints: 1440,
			info: 1440,
			labels: 10,
			menus: 30,
			redirects: 60,
			rotators: 10,
			routes: 5,
			token: 1440,
			newsletter: 1440,
			gdprTemplate: 1440,
			thumbs: 180,
			cmsPages: 60,
			catalogCategories: 5,
			catalogLists: 5,
			catalogManufacturers: 30,
			catalogProducts: 5,
			catalogProduct: 5,
			catalogSellers: 5,
			faqCategories: 60,
			faqQuestions: 60,
			faqQuestion: 60,
			publishCategories: 60,
			publishPost: 30,
			publishPosts: 30,
			locationPoints: 60,
			staticContent: 60,
		},
	},
	layouts: [
		{
			template: [
				'WebshopLogin',
				'WebshopCustomer',
				'WebshopShipping',
				'WebshopReviewOrder',
				'WebshopThankYou',
				'WebshopCancelOrder',
				'WebshopFailedOrder',
				'WebshopFailedPayment',
				'WebshopPaymentCreate',
				'WebshopPaymentNew',
				'WebshopPaymentOnHold',
				'WebshopPaymentFormAutosubmit',
				'WebshopViewAdditionalpayment',
				'WebshopAdditionalpaymentsThankYou',
			],
			layout: 'checkout',
		},
		{
			template: ['AuthLogin', 'AuthLogout'],
			layout: 'spinner',
		},
	],
	fetchApi: {
		put: {
			appendLang: false,
		},
	},
	catalog: {
		productsResponseFields: [
			'active_shipping_options_count',
			'attributes_special',
			'availability_info',
			'available_qty',
			'badges_special_1',
			'badges_special_2',
			'basic_price_custom',
			'category_title',
			'category_url_without_domain',
			'code',
			'date_available',
			'discount_percent_custom',
			'extra_price_cart_dynamicprice',
			'extra_price_dynamicprice',
			'extra_price_mode_dynamicprice',
			'feedback_comment_widget',
			'feedback_rate_widget',
			'id',
			'installments_calculation',
			'is_available',
			'is_rate',
			'last_piece_sale',
			'loyalty_price_custom',
			'main_image_description',
			'main_image_title',
			'main_image_upload_path',
			'main_image_thumbs',
			'price_custom',
			'product_condition',
			'quantity',
			'selected_price',
			'seller_id',
			'seller_title',
			'seller_url_product_page_without_domain',
			'seller_url_without_domain',
			'shipping_date',
			'shipping_options',
			'shopping_cart_code',
			'status',
			'title',
			'type',
			'url_without_domain',
			'warehouses_single_pickup_display',
			'xxx',
		],
		fetch: {
			check_lists: config.default === 'prod' || config.default === 'beta' ? 'webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_1219026' : 'webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_2225499',
			appconfig: 'product_pim_min_chars',
		},
		hooks: {
			mapProduct: product => {
				if (product?.type == 'configurable' && product?.initial_offer) {
					return product.initial_offer;
				}
				return product;
			},
		},
	},
	keycloak: true,
	auth: {
		loggedOutRedirect: 'home',
	},
	structuredData: {
		enabled: true,
		basic: {
			name: 'Big Bang',
			organizationName: 'Big Bang',
			logo: 'https://www.bigbang.si/media/images/logo-mail.png', // FIXME INTEG privremeni logo
			phone: '013626000',
			email: 'info@bigbang.si',
			socialNetworkUrls: '"https://www.facebook.com/BigBangSlovenija?ref=hl","https://www.instagram.com/bigbangslo/","https://www.youtube.com/user/BigBangSlovenija","https://www.linkedin.com/company/big-bang-slovenija"',
		},
	},
});
